<script>
  import { onMount } from 'svelte';
  import { carregaCategoria, editaCategoria, deletaCategoria } from '../../actions/database.js';

  import Page from "../../containers/Page/Page.svelte";
  import Modal from "../../components/Modal/Modal.svelte";

  export let params = {}

  let categoria;
  let alert;
  let error;

  onMount(async () => {
    categoria = await carregaCategoria(params.id);
  });

  const handleEdit = async () => {
    alert = "Atualizando...";
    try {
      await editaCategoria(categoria);
      alert = "Categoria atualizada!";
    } catch (error) {
      alert = `Erro ao atualizar a categoria: ${error}`;
    }
  }

  const handleDelete = async () => {
    const ask = confirm(
      `Você tem certeza que quer deletar a categoria?`
    );

    if (!ask) return false;

    alert = "Deletando...";
    try {
      await deletaCategoria(categoria);
      alert = "Categoria deletada!";
    } catch (error) {
      alert = `Erro ao atualizar a categoria: ${error}`;
    }
  }

  const close = () => alert = null;
</script>

{#if alert}
  <Modal
    { alert }
    { close }
  />
{/if}

{#if categoria}
  
<Page title="Editar Categoria">
  <div class="box">
    <div class="field is-horizontal">
      <div class="content">
        <h3>Dados da categoria:</h3>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Nome</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control is-expanded">
            <input bind:value={categoria.nome} class="input" type="text">
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Ativo</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <div class="select">
              <select bind:value={categoria.ativo}>
                <option value="nao">Não</option>
                <option value="sim">Sim</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Descrição</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <textarea bind:value={categoria.descricao} class="textarea"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="control has-text-right">
      <button
        on:click={handleDelete}
        class="button is-danger"
      >
        Deletar categoria
      </button>
      <button
        on:click={handleEdit}
        class="button is-primary"
      >
        Editar categoria
      </button>
    </div>
  </div>

</Page>
{/if}

<style>
  .error.notification {
    padding: 10px;
  }
</style>